import React, { useState, Fragment } from "react";
import Alert from "../layout/Alert";
import { setAlert } from "../../action/alert";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Tab, Box, CircularProgress, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import Grid from "@mui/material/Grid";
import { uploadMatterCD, fetchMatterCD, deleteMatterCD } from "../../action/matterCD";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadCDForm from './UploadCDForm'
import GetCDForm from "./GetCDForm"
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";

const activeTabSx = { border: "1px solid #bdbdbd", backgroundColor: "#e0e0e0", color: "#333333", textTransform: "capitalize" };
const nonActiveTabSx = { border: "none", backgroundColor: "none", color: "#333333", textTransform: "capitalize" };

const MatterCD = () => {
  const [activeTab, setActiveTab] = useState(0);

  React.useEffect(() => {
    const switchToUploadTabHandler = () => setActiveTab(0);
    window.addEventListener("switchToUploadTab", switchToUploadTabHandler);
    return () => {
      window.removeEventListener("switchToUploadTab", switchToUploadTabHandler);
    };
  }, []);

  return (
    <ResponsiveContentWrapper>
      <div className="row">
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          TabIndicatorProps={{ style: { backgroundColor: "#bdbdbd" } }}
          style={{ marginTop: 0 }}
        >
          <Tab
            label="Upload CD"
            sx={activeTab === 0 ? activeTabSx : nonActiveTabSx}
          />
          <Tab
            label="Get CD"
            sx={activeTab === 1 ? activeTabSx : nonActiveTabSx}
          />
        </Tabs>
        <div hidden={activeTab !== 0}>
          <UploadCDForm activeTab={activeTab} />
        </div>
        <div hidden={activeTab !== 1}>
          <GetCDForm />
        </div>
      </div>
    </ResponsiveContentWrapper>
  );
};

export default MatterCD;
